var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.74782C0 3.23832 1.85794 1.1196 4.35318 0.852376C7.96478 0.465602 13.1185 0 17 0C20.8815 0 26.0352 0.465602 29.6468 0.852376C32.1421 1.1196 34 3.23832 34 5.74783V28.0178C34 30.4549 32.2426 32.5353 29.829 32.8726C26.2153 33.3777 20.9598 34 17 34C13.0402 34 7.78473 33.3777 4.171 32.8726C1.75742 32.5353 0 30.4549 0 28.0178V5.74782Z",
    fill: "#D1E1F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66671 25.2502C9.16254 25.2502 8.73094 25.0706 8.37192 24.7116C8.01289 24.3526 7.83337 23.921 7.83337 23.4168V13.3335C7.83337 12.8293 8.01289 12.3977 8.37192 12.0387C8.73094 11.6797 9.16254 11.5002 9.66671 11.5002H13.3334V9.66683C13.3334 9.16266 13.5129 8.73107 13.8719 8.37204C14.2309 8.01301 14.6625 7.8335 15.1667 7.8335H18.8334C19.3375 7.8335 19.7691 8.01301 20.1282 8.37204C20.4872 8.73107 20.6667 9.16266 20.6667 9.66683V11.5002H24.3334C24.8375 11.5002 25.2691 11.6797 25.6282 12.0387C25.9872 12.3977 26.1667 12.8293 26.1667 13.3335V23.4168C26.1667 23.921 25.9872 24.3526 25.6282 24.7116C25.2691 25.0706 24.8375 25.2502 24.3334 25.2502H9.66671ZM15.1667 11.5002H18.8334V9.66683H15.1667V11.5002Z",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.c1c12c13e7ad8d3fc64bbca3c6795c30.svg";
export { ForwardRef as ReactComponent };